import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, HeartHandshake, Compass, Users, Award } from "lucide-react";
import { stats } from "../mock";

const values = [
  { icon: HeartHandshake, title: "Serving with Love", text: "Every engagement starts with empathy — for our customers, their customers, and our own people." },
  { icon: Compass, title: "Customer First", text: "We measure success by the outcomes we create for your business, not the hours we bill." },
  { icon: Users, title: "People Powered", text: "4,500+ technologists across India, learning fast and solving faster." },
  { icon: Award, title: "Excellence Always", text: "Three decades of delivery discipline, certified processes and trusted partnerships." },
];

const AboutPage = () => {
  const navigate = useNavigate();
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <main className="bg-[#050f24] min-h-screen">
      <section className="relative pt-44 pb-24 overflow-hidden">
        <div className="absolute right-0 top-20 w-[600px] h-[600px] rounded-full bg-blue-600/12 blur-3xl" />
        <div className="absolute left-0 bottom-0 w-[400px] h-[400px] rounded-full bg-white/7 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-white text-sm font-semibold tracking-wide uppercase mb-4">Who We Are</p>
          <h1 className="text-white text-4xl sm:text-5xl lg:text-[64px] font-bold max-w-3xl leading-[1.06]" style={{ fontFamily: "Archivo, sans-serif" }}>
            The experts behind your digital journey
          </h1>
          <p className="text-white/70 text-lg leading-relaxed mt-8 max-w-2xl">
            ZoofyTechX began with a simple idea: help businesses thrive through technology. Today we're one of India's
            most trusted IT partners — turning opportunities into results for enterprises across every major industry.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {stats.map((s) => (
            <div key={s.label} className="bg-[#0b2044] border border-white/10 rounded-2xl p-8 text-center">
              <p className="text-white text-4xl font-bold" style={{ fontFamily: "Archivo, sans-serif" }}>
                {s.value.toLocaleString("en-IN")}{s.suffix}
              </p>
              <p className="text-white/60 mt-2">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <h2 className="text-white text-3xl lg:text-4xl font-bold mb-12" style={{ fontFamily: "Archivo, sans-serif" }}>
          What we stand for
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="bg-[#0b2044] border border-white/10 rounded-2xl p-7 hover:border-white/40 transition-colors">
              <v.icon size={30} className="text-white mb-5" strokeWidth={1.6} />
              <h3 className="text-white font-bold text-lg mb-2" style={{ fontFamily: "Archivo, sans-serif" }}>{v.title}</h3>
              <p className="text-white/60 text-[15px] leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-28 text-center">
        <h2 className="text-white text-3xl lg:text-4xl font-bold mb-6" style={{ fontFamily: "Archivo, sans-serif" }}>
          Ready to transform with us?
        </h2>
        <button
          onClick={() => navigate("/contact")}
          className="inline-flex items-center gap-2 bg-white hover:bg-[#d7e3f4] text-[#04122e] text-sm font-bold px-8 py-3 rounded-full transition-colors"
        >
          Let's Connect <ArrowRight size={16} />
        </button>
      </section>
    </main>
  );
};

export default AboutPage;
